import { fabric } from "fabric";
import { PDFDocument} from 'pdf-lib'
import  Axios from "axios";
import pdfBase from "./pdfBase";
import { CanvasThingie } from "./PdfSelfSignEventMethods";
import "./pdfCanvas.css";
import './fabricExtensions'
import { DrawingEditor, DrawingMode } from "./FabricDrawers";


export type CanvasWithObject = {
    canvasElement: HTMLCanvasElement,
    fabricObject: fabric.Object
}

export type PageChangeCallback = (pageNumber: number) => any;

interface SignatureImageData {
    svgElement: string;
    dataUrl: string;
}

export class PdfCanvas extends pdfBase {
    // fabricCanvases: fabric.Canvas[] = new Array<fabric.Canvas>();
    element: HTMLElement | null = null
    public canvasObjects: CanvasThingie[] = new Array<CanvasThingie>();
    currentPage: number = 1;
    originalWidth: number = 0;
    originalHeight: number = 0;
    currentCanvasObjectIndex: number = -1;
    public scale: number = this.getScaleByUserAgent();
    get totalPages(): number {
        return this.canvasObjects.length > 0 ? this.canvasObjects.length : 1;
    }
    get activeCanvas(): fabric.Canvas {
        return this.canvasObjects[this.currentPage - 1].fabricCanvas;
    }


    async init(source: string, element: HTMLElement | null) {
        if (!await super.initialize(source)) return;
        if (element === null) {
            throw new Error("The parameter \"element\" cannot be null.");
        }
        this.element = element;
        element.onscroll = this.handlePdfScroll;
        for (let i = 1; i < this.numberOfPages + 1; i++) { //Page numbers are 1 based index.
            let page = await this.doc?.getPage(i);
            const canvas: HTMLCanvasElement = document.createElement('canvas');
            canvas.id = `pdf${i}`; // 
            let context: CanvasRenderingContext2D;
            context = canvas.getContext("2d") || new CanvasRenderingContext2D();
            // let viewport = page?.getViewport({ scale: source ? 3 : 1 });
            let viewport = page?.getViewport({ scale: this.scale });
            // console.log(viewport?.width, viewport?.height)

            canvas.width = (viewport?.width || 800);
            canvas.height = (viewport?.height || 1150);
            this.originalWidth = canvas.width;
            this.originalHeight = canvas.height;

            // //150 DPI
            // canvas.width = 8.5*150;
            // canvas.height = 11*150;

            //Wait for the page to render, or the bg variable will not be set.
            //That will cause the pdf to disappear when drawing on the pdf.
            await page?.render({ canvasContext: context, viewport: viewport }).promise;

            let bgImageDataUrl = canvas.toDataURL();

            // element.appendChild(canvas);
            const blankCanvas = document.createElement('canvas');
            if (source) blankCanvas.classList.add('pdf-viewer');
            blankCanvas.width = (viewport?.width || 800);
            blankCanvas.height = (viewport?.height || 1150);
            element.append(blankCanvas);
            let fabricCanvas = new fabric.Canvas(blankCanvas, {
                selection: false,
                fireRightClick: true,
                preserveObjectStacking: true
            });
            fabricCanvas.pageNumber = i;
            this.canvasObjects.push({ fabricCanvas, canvas: blankCanvas, bgImageDataUrl, drawingEditor: new DrawingEditor(fabricCanvas, DrawingMode.Rectangle) });
            fabric.Image.fromURL(bgImageDataUrl, (img) => {
                fabricCanvas.setBackgroundImage(img, fabricCanvas.renderAll.bind(fabricCanvas), {
                    scaleX: fabricCanvas.getWidth() / (img.width || 0),
                    scaleY: fabricCanvas.getHeight() / (img.height || 0)
                })
            })
            // fabricCanvas.setBackgroundImage(bgImageDataUrl, fabricCanvas.renderAll.bind(fabricCanvas));

            if (canvas.parentElement) {
                canvas.parentElement.hidden = true;
            }
            canvas.remove();
        }
        this.showPage(1);
        this.addDeleteEventListener();
    }

    addDeleteEventListener() {
        document.addEventListener('keydown', (e)=>{
            if(e.code === "Delete"){
                this.deleteAciveItems();
                this.currentCanvasObjectIndex = 0;
            }
        });
    }

    deleteAciveItems() {
        this.canvasObjects.forEach(x => {
            let activeObjects = x.fabricCanvas.getActiveObjects();
            activeObjects.forEach(fabricObject => {
                x.fabricCanvas.remove(fabricObject);
            });
        });
    }

    getScaleByUserAgent(): number {
        var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

        if (isSafari) {
            return 1;
        }

        const isMobileDevice = () => {
            return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
        }

        if (isMobileDevice()) {

            return 1;
        }

        return 3;

    }

    public setDrawingMode(isDrawingMode: boolean) {
        this.canvasObjects.forEach(x => x.fabricCanvas.isDrawingMode = isDrawingMode);
    }

    public setTypingMode(pointerObj: any, color: string, font: string) {
        let currCanvas = this.activeCanvas
        let newText = new fabric.IText('', {
            left: pointerObj.x,
            top: pointerObj.y,
            fontFamily: font || 'Times New Roman',
            fill: color,
            fontSize: 16
        })
        currCanvas.add(newText);
        currCanvas.setActiveObject(newText);
        newText.enterEditing();
        newText.hiddenTextarea?.focus();
    }

    public setBrushWidth(width: number) {
        this.canvasObjects.forEach(x => x.fabricCanvas.freeDrawingBrush.width = width);
    }

    public setDrawColor(color: string) {
        this.canvasObjects.forEach(x => x.fabricCanvas.freeDrawingBrush.color = color);
    }

    public getActiveObject(): fabric.Object {
        return this.canvasObjects[this.currentPage - 1].fabricCanvas.getActiveObject();
    }

    public addPath(pageNumber: number, drawObject: any) {
        let newObj
        let index = this.convertPageNumberToIndex(pageNumber);
        if (drawObject.type === "path") {
            fabric.Path.fromObject(drawObject, (x: any) => {
                newObj = x;
                this.canvasObjects[index].fabricCanvas.add(x);
                if (newObj) {
                    newObj.set({ opacity: 0 });
                    newObj.animate("opacity", 100, {
                        duration: 5000,
                        onChange: this.canvasObjects[index].fabricCanvas.renderAll.bind(this.canvasObjects[index].fabricCanvas),
                    });
                }
            });

        } else if (drawObject.type === 'i-text') {
            // console.log("fabric draw other type, in this case, a text box");
            // this is where I have to do the logic for text, I think.
            // console.log(drawObject)
            fabric.IText.fromObject(drawObject, (x: any) => {
                newObj = x;
                this.canvasObjects[index].fabricCanvas.add(x);
                if (newObj) {
                    newObj.set({ opacity: 0 });
                    newObj.animate("opacity", 100, {
                        duration: 5000,
                        onChange: this.canvasObjects[index].fabricCanvas.renderAll.bind(this.canvasObjects[index].fabricCanvas),
                    });
                }
            })

        } else {
            fabric.Object._fromObject('Rect', drawObject, (x: any) => {
                newObj = x;
                this.canvasObjects[index].fabricCanvas.add(x);
                if (newObj) {
                    newObj.set({ opacity: 0 });
                    newObj.animate("opacity", 100, {
                        duration: 5000,
                        onChange: this.canvasObjects[index].fabricCanvas.renderAll.bind(this.canvasObjects[index].fabricCanvas),
                    });
                }
            })
        }
    }

    public removeCanvasObject(pageNumber: number, key: string) {
        var index = this.convertPageNumberToIndex(pageNumber);
        var targetCanvas = this.canvasObjects[index].fabricCanvas;
        let objectToRemove = targetCanvas.getItemByAttr("_key", key);
        if (objectToRemove) targetCanvas.remove(objectToRemove);
    }

    public convertPageNumberToIndex(pageNumber: number): number {
        pageNumber = pageNumber ? pageNumber : 0
        var page: number = pageNumber - 1;
        page = page < 0 ? 0 : page;
        page = page >= this.canvasObjects.length ? this.canvasObjects.length - 1 : page;
        return page;
    }

    public addPageChangeListener(listener: PageChangeCallback) {
        this.addListener("page-change", listener);
    }

    handlePdfScroll = (event: Event) => {
        let container = event.target as Element;

        //This way changes the page number as soon as the previous page is out of view.
        for (let i = 0; i < this.canvasObjects.length; i++) {
            const element = this.canvasObjects[i].canvas;
            let isElementVisible = this.isElementInViewPort(container, element);
            if (isElementVisible) {
                this.currentPage = i + 1;
                // this.emit()
                this.emit("page-change", this.currentPage);
                break;
            }
        }
    }

    isElementInViewPort = (container: Element, el: HTMLElement) => {
        let rect = el.getBoundingClientRect();
        let containerRect = container.getBoundingClientRect();
        // debugger;
        // return (rect.top > containerRect.bottom || rect.bottom >)
        return (rect.top + rect.height > containerRect.top
            && rect.left + rect.width > containerRect.left
            && rect.bottom - rect.height < containerRect.bottom
            && rect.right - rect.width < containerRect.right)
        // Partially visible elements return true:
        // el.heigh 
        // let isVisible = rect.top < window.innerHeight && rect.bottom >= 0;
        // return isVisible;
    }

    public showPage(pageNumber: number, scroll: boolean = false) {
        var page = this.convertPageNumberToIndex(pageNumber);
        this.currentPage = page + 1;

        if (scroll) {
            const element = this.canvasObjects[page].canvas.parentElement;
            if (element) {
                element.scrollIntoView();
            }
            return;
        }

        for (let i = 0; i < this.canvasObjects.length; i++) {
            const element = this.canvasObjects[i].canvas.parentElement;
            if (element) {
                element.hidden = true;
            }
        }

        var currentPageElement = this.canvasObjects[page].canvas.parentElement
        if (currentPageElement) {
            currentPageElement.hidden = false;
        }
    }

    public showAllPages() {
        for (let i = 0; i < this.canvasObjects.length; i++) {
            const element = this.canvasObjects[i].canvas.parentElement;
            if (element) {
                element.hidden = false;
            }
        }
    }

    getCanvasObjects = (): Array<CanvasWithObject> => {
        // return this._pdfViewer.canvasObjects.map(x=>x.fabricCanvas).reduce((x,y)=>x.concat);
        let result = this.canvasObjects
            .map(x => {
                return {
                    fabric: x.fabricCanvas,
                    canvas: x.canvas
                }
            })
            .reduce((a: Array<CanvasWithObject>, b) => {
                //return a.concat(b.fabric)
                let items: CanvasWithObject[] = [];
                b.fabric._objects.forEach(x => {
                    items.push({ canvasElement: b.canvas, fabricObject: x })
                })
                return a.concat(items)
            }, [])
            .sort((a, b) => {
                return (a.fabricObject.canvas?.pageNumber || 0) - (b.fabricObject.canvas?.pageNumber || 0)
                    || (a.fabricObject.top || 0) - (b.fabricObject.top || 0);//sort by pagenumber and top in ascending order.
            });
        return result;
    }

    getInputObjects = (): Array<CanvasWithObject> => {
        return this.getCanvasObjects().filter(x => x.fabricObject.inputType);
    }

    public getFabricCanvasByPageNumber(pageNumber: number): fabric.Canvas {
        return this.canvasObjects[this.convertPageNumberToIndex(pageNumber)].fabricCanvas;
    }

    public clearCurrentPage() {
        this.clearPage(this.currentPage);
    }

    public clearPage(pageNumber: number) {
        var index = this.convertPageNumberToIndex(pageNumber);
        this.clearPageByIndex(index);
    }

    private clearPageByIndex(index: number) {
        var canvasObject = this.canvasObjects[index];
        canvasObject.fabricCanvas.clear();
        canvasObject.fabricCanvas.setBackgroundImage(canvasObject.bgImageDataUrl, canvasObject.fabricCanvas.renderAll.bind(canvasObject.fabricCanvas));
    }

    public clearAllPages() {
        for (let i = 0; i < this.totalPages; i++) {
            this.clearPageByIndex(i);
        }
    }

    public nextPage(scroll: boolean = false) {
        if (this.currentPage >= this.canvasObjects.length) {
            return;
        }
        this.currentPage++;
        this.showPage(this.currentPage, scroll);
    }

    public previousPage(scroll: boolean = false) {
        if (this.currentPage <= 1) {
            return;
        }
        this.currentPage--;
        this.showPage(this.currentPage, scroll);
    }

    public allPageCount() {
        return this.canvasObjects.length
    }

    public zoomIn = async () => {
        let currCanvas = this.activeCanvas
        let scaleRatio = currCanvas.getZoom() + 0.1
        // currCanvas.setDimensions({ width: this.originalWidth * scaleRatio, height: this.originalHeight * scaleRatio });
        // console.log('scale ratio', scaleRatio)
        // console.log('width x height', currCanvas.getWidth(), ' x ', currCanvas.getHeight())
        currCanvas.setZoom(scaleRatio)
        return
    }

    public zoomOut = async () => {
        let currCanvas = this.activeCanvas
        let scaleRatio = currCanvas.getZoom() - 0.1
        // currCanvas.setDimensions({  width: this.originalWidth * scaleRatio, height: this.originalHeight * scaleRatio });
        // console.log('scale ratio', scaleRatio)
        // console.log('width x height', currCanvas.getWidth(), ' x ', currCanvas.getHeight())

        currCanvas.setZoom(scaleRatio)
        return
    }
    // async buildCanvases(url: string): Promise<CanvasThingie[]> {
    //     let canvases = new Array<CanvasThingie>();
    //     var doc = await pdfjsLib.getDocument(url).promise;
    //     this.pdfBytes = await doc.getData();
    //     var numberOfPages = doc.numPages;
    //     for (let i = 1; i < numberOfPages + 1; i++) { //Page numbers are 1 based index.
    //         var page = await doc.getPage(i);
    //         const canvas = document.createElement('canvas');
    //         canvas.id = `pdf${i}`;
    //         let context: CanvasRenderingContext2D;
    //         context = canvas.getContext("2d") || new CanvasRenderingContext2D();
    //         var viewport = page.getViewport({ scale: 1 });
    //         canvas.width = viewport.width;
    //         canvas.height = viewport.height;

    //         //Wait for the page to render, or the bg variable will not be set.
    //         //That will cause the pdf to disappear when drawing on the pdf.
    //         await page.render({ canvasContext: context, viewport: viewport }).promise;

    //         var bgImageDataUrl = canvas.toDataURL("image/png");

    //         var fabricCanvas = new fabric.Canvas(canvas, {
    //             selection: false,
    //             preserveObjectStacking: true
    //         });
    //         this.fabricCanvases.push(fabricCanvas);
    //         fabricCanvas.setBackgroundImage(bgImageDataUrl, fabricCanvas.renderAll.bind(fabricCanvas));
    //         fabricCanvas.isDrawingMode = true;
    //         canvases.push({ fabricCanvas, canvas, bgImageDataUrl })
    //     }


    //     return canvases

    // }


    getSignatureImageData(): SignatureImageData[] {
        var imageData = new Array<SignatureImageData>();
        this.canvasObjects.forEach(x => {
            if (x.fabricCanvas !== null) {
                var backgroundImage = x.fabricCanvas.backgroundImage;
                x.fabricCanvas.backgroundImage = undefined;
                // var dataUrl = x..toDataURL({ format: "image/png" });
                var svgString = x.fabricCanvas.toSVG({ suppressPreamble: true });
                x.fabricCanvas.backgroundImage = backgroundImage;
                imageData.push({ dataUrl: x.bgImageDataUrl, svgElement: svgString })
            }
        });
        return imageData;
    }

    // public async drawSvgPathsOnPdf(pdfUrl: string = "", svg: string = ""): Promise<Uint8Array> {
    //     debugger;
    //     if (!pdfUrl) {
    //         pdfUrl = this.source;
    //     }
    //     if (!svg) {
    //         svg = this.getSignatureImageData().svgElement;
    //     }
    //     // var svgElement = 
    //     svg = "M 572.2415672753988 394.56137017804156 Q 572.2405672753988 394.56237017804153 572.2405672753988 395.06177670623146 Q 572.2405672753988 395.5611832344214 570.7430861670864 397.0594028189911 Q 569.2456050587741 398.55762240356086 567.2489635810243 400.5552485163205 Q 565.2523221032745 402.5528746290801 562.2573598866499 405.0499072700297 Q 559.2623976700252 407.54693991097923 555.7682750839631 411.0427856083086 Q 552.2741524979009 414.538631305638 547.7817091729639 418.53388353115724 Q 543.2892658480268 422.52913575667657 537.2993414147775 426.5243879821959 Q 531.3094169815281 430.51964020771516 525.3194925482787 435.51370548961427 Q 519.3295681150294 440.5077707715134 511.84216257346765 446.00124258160236 Q 504.35475703190593 451.4947143916914 495.8690307514693 456.4887796735905 Q 487.3833044710327 461.4828449554896 477.8992574517212 466.97631676557864 Q 468.4152104324097 472.4697885756677 458.43200304366076 477.9632603857567 Q 448.4487956549118 483.4567321958457 437.96642789672546 487.95139094955493 Q 427.48406013853906 492.4460497032641 417.00169238035267 496.4413019287834 Q 406.51932462216627 500.43655415430266 396.03695686397987 503.93239985163206 Q 385.55458910579347 507.42824554896146 375.5713817170445 509.92527818991096 Q 365.58817432829557 512.4223108308605 356.6032876784215 513.4211238872404 Q 347.61840102854745 514.4199369436202 339.6318351175483 514.9193434718102 Q 331.64526920654913 515.41875 324.65702403442486 514.9193434718102 Q 317.6687788623006 514.4199369436202 312.1780147984887 511.4234977744807 Q 306.68725073467675 508.42705860534124 302.69396777917717 504.93121290801184 Q 298.7006848236776 501.4353672106825 295.7057226070529 495.94189540059347 Q 292.7107603904282 490.4484235905045 290.71411891267843 484.45554525222553 Q 288.71747743492864 478.4626669139466 288.2183170654912 471.97038204747776 Q 287.71915669605374 465.47809718100893 287.71915669605374 458.48640578635013 Q 287.71915669605374 451.4947143916914 289.2166378043661 444.50302299703264 Q 290.71411891267843 437.5113316023739 293.7090811293031 430.02023367952523 Q 296.7040433459278 422.52913575667657 301.19648667086483 415.5374443620178 Q 305.68892999580186 408.5457529673591 311.1796940596138 402.5528746290802 Q 316.6704581234257 396.5599962908012 323.1595429261125 391.5659310089021 Q 329.64862772879934 386.571865727003 337.6351936397985 383.0760200296736 Q 345.62175955079766 379.5801743323442 354.10748583123427 377.08314169139464 Q 362.5932121116709 374.5861090504451 372.0772591309824 374.0867025222552 Q 381.5613061502939 373.5872959940653 392.0436739084803 374.5861090504451 Q 402.5260416666667 375.58492210682493 413.50756979429053 377.58254821958457 Q 424.4890979219144 379.5801743323442 436.96810715785057 383.57542655786347 Q 449.4471163937867 387.5706787833828 461.9261256297229 392.5647440652819 Q 474.4051348656591 397.558809347181 487.88246484047016 404.55050074183976 Q 501.35979481528125 411.5421921364985 515.3362851595298 419.5326965875371 Q 529.3127755037783 427.5232010385757 542.7901054785893 436.5125185459941 Q 556.2674354534005 445.5018360534125 569.7447654282116 455.4899666172107 Q 583.2220954030226 465.47809718100893 596.2002650083963 475.965634272997 Q 609.1784346137699 486.45317136498517 621.6574438497062 497.4401149851632 Q 634.1364530856423 508.42705860534124 646.6154623215784 519.4140022255193 Q 659.0944715575147 530.4009458456974 670.5751600545759 541.3878894658753 Q 682.0558485516373 552.3748330860534 693.0373766792611 563.8611832344213 Q 704.018904806885 575.3475333827894 712.5046310873215 583.3380378338279 Q 720.9903573677582 591.3285422848664 728.9769232787573 599.319046735905 Q 736.9634891897565 607.3095511869436 745.4492154701932 614.3012425816023 Q 753.9349417506297 621.2929339762611 760.923186922754 627.2858123145401 Q 767.9114320948783 633.278690652819 774.8996772670025 637.2739428783383 Q 781.8879224391268 641.2691951038576 786.8795261335013 643.2668212166172 Q 791.8711298278757 645.2644473293768 796.3635731528127 645.7638538575668 Q 800.8560164777498 646.2632603857567 804.3501390638119 645.2644473293769 Q 807.844261649874 644.2656342729971 810.3400634970612 642.2680081602374 Q 812.8358653442485 640.2703820474777 815.3316671914358 637.7733494065282 Q 817.827469038623 635.2763167655786 820.8224312552477 632.2798775964392 Q 823.8173934718724 629.2834384272998 827.3115160579346 625.2881862017805 Q 830.8056386439966 621.2929339762611 834.7989215994962 617.2976817507418 Q 838.7922045549958 613.3024295252226 842.2863271410579 609.3071772997033 Q 845.7804497271201 605.311925074184 848.7754119437448 600.8172663204748 Q 851.7703741603694 596.3226075667656 855.2644967464316 592.3273553412463 Q 858.7586193324937 588.332103115727 861.254421179681 584.3368508902078 Q 863.7502230268682 580.3415986646885 864.7485437657431 575.8469399109792 Q 865.746864504618 571.35228115727 865.746864504618 566.8576224035608 Q 865.746864504618 562.3629636498516 863.7502230268682 556.8694918397625 Q 861.7535815491184 551.3760200296736 856.7619778547439 545.3831416913947 Q 851.7703741603694 539.3902633531158 846.778770465995 531.8991654302671 Q 841.7871667716205 524.4080675074184 833.3014404911839 515.9181565281899 Q 824.8157142107473 507.42824554896146 813.335025713686 497.93952151335316 Q 801.8543372166247 488.4507974777448 786.3803657640638 479.4614799703264 Q 770.9063943115029 470.47216246290805 751.9383002728799 460.4840318991098 Q 732.9702062342569 450.4959013353116 710.5079896095717 441.00717729970324 Q 688.0457729848866 431.51845326409494 664.5852356213265 422.52913575667657 Q 641.1246982577666 413.5398182492582 616.6658401553316 405.04990727002973 Q 592.2069820528967 396.5599962908012 567.2489635810243 388.56949183976263 Q 542.290945109152 380.57898738872404 517.8320870067171 373.0878894658754 Q 493.3732289042821 365.5967915430267 470.4118519101595 359.1045066765579 Q 447.4504749160369 352.612221810089 425.4874186607892 346.1199369436202 Q 403.5243624055416 339.62765207715137 383.5579476280437 334.13418026706233 Q 363.5915328505458 328.6407084569733 345.1225991813602 323.6466431750742 Q 326.65366551217465 318.6525778931751 309.68221295130144 314.1579191394659 Q 292.7107603904282 309.6632603857567 277.7359493073048 306.16741468842736 Q 262.76113822418137 302.67156899109796 250.28212898824518 299.6751298219585 Q 237.803119752309 296.678690652819 227.3207519941226 294.18165801186944 Q 216.8383842359362 291.6846253709199 208.35265795549958 290.1864057863502 Q 199.86693167506297 288.6881862017804 193.8770072418136 287.18996661721064 Q 187.88708280856423 285.69174703264093 183.89379985306465 284.6929339762611 Q 179.90051689756507 283.6941209198813 177.90387541981528 283.6941209198813 Q 175.9072339420655 283.6941209198813 175.40807357262804 283.6941209198813 Q 174.9089132031906 283.6941209198813 175.9072339420655 283.6941209198813 Q 176.90555468094038 283.6941209198813 179.90051689756507 284.1935274480712 Q 182.89547911418975 284.69293397626114 186.3896017002519 285.19234050445107 L 189.88472428631403 285.6927470326409";
    //     // PDFDocument.
    //     const pdfDoc = await PDFDocument.load(this.pdfBytes || pdfUrl);
    //     const page = pdfDoc.getPage(0);
    //     page.moveTo(100, page.getHeight() - 5);
    //     page.drawSvgPath(svg);

    //     var bytes = await pdfDoc.save();
    //     return bytes;
    // }

    // public async addPngToPdf(pdfUrl: string = "", imageDataUrl: string = ""): Promise<Uint8Array> {
    public async addPngsToPdf(): Promise<Uint8Array> {
        var imageData = this.getSignatureImageData();
        var pdfUrl = this.source;
        const pdfDoc = await PDFDocument.load(this.pdfBytes || pdfUrl);


        for (let index = 0; index < imageData.length; index++) {
            // debugger;
            const page = pdfDoc.getPage(index); //For pdf-lib pages are 0 index.
            // const pngImageBytes = await (await fetch(x.dataUrl)).arrayBuffer();
            const pngImageBytes = await (await fetch(imageData[index].dataUrl)).arrayBuffer();
            // const pngImageBytes = await (await fetch(x.dataUrl)).arrayBuffer();
            const pngImage = await pdfDoc.embedPng(pngImageBytes);
            page.drawImage(pngImage);
        }

        var bytes = await pdfDoc.save();
        return bytes;
    }

    public async postPdf(bytes: Uint8Array) {
        var formData = new FormData();
        if (this.pdfBytes == null) {
            throw new Error("PdfBytes cannot be null.")
        }
        // api call to get the file, get the file name from the file that was just grabbed. 
        formData.append("signedDocument", new Blob([bytes]), 'fileNameParameter');
        // TODO: change from Axios to the apiService to have authorization embedded
        var result = await Axios.post("https://hingeapilocal.illuminatingsoftware.com/09c6bcbb-75e4-11ea-b50b-ac1f6b59f7b6/meetings/0f11bd23-75ec-11ea-b50b-ac1f6b59f7b6/files",
            formData,
            { headers: { "Content-Type": "multipart/form-data" } }
        );
        // debugger;
        console.log("Post file result:", result);
    }

    goToPreviousInput = (offset: number = 50) => {
        let canvasObjects = this.getCanvasObjects();
        if (canvasObjects.length === 0) {
            return;
        }
        let currentObjectIndex = (this.currentCanvasObjectIndex - 1) <= 0 ? 0 : this.currentCanvasObjectIndex - 1;
        this.currentCanvasObjectIndex = currentObjectIndex;
        let canvasWithObject = canvasObjects[currentObjectIndex];
        this.setInput(canvasWithObject, offset);
    }

    goToNextInput = (offset: number = 50) => {
        let canvasObjects = this.getCanvasObjects();
        if (canvasObjects.length === 0) {
            return;
        }
        let currentObjectIndex = (this.currentCanvasObjectIndex + 1) >= canvasObjects.length ? canvasObjects.length - 1 : this.currentCanvasObjectIndex + 1;
        this.currentCanvasObjectIndex = currentObjectIndex;
        let canvasWithObject = canvasObjects[currentObjectIndex];
        this.setInput(canvasWithObject, offset);
    }

    setInput = (canvasWithObject: CanvasWithObject, offset: number) => {
        let canvas = canvasWithObject.canvasElement;

        // canvasWithObject.fabricObject.canvas?.setActiveObject(canvasWithObject.fabricObject)

        // debugger;
        // let unknownQuantity = 60
        let canvasParent = canvas.parentElement;
        if (!canvasParent) {
            throw new Error("Unable to get the canvas parent element.");
        }
        // let top = (canvas.parentElement as HTMLElement).offsetTop - unknownQuantity;
        let fabricObject = canvasWithObject.fabricObject;
        let topPercent = this.calculateTopPercent(fabricObject) / 100.0;
        let fabricOffset = topPercent * (canvas.clientHeight); //Be sure to use client hight here.  height does not work.

        //offsetTop does not include the margin of the element, se we need to get that seperately.
        //the top position, and margin of the element
        //the top padding, scrollbar and border of the offsetParent element
        // const canvasContainerMarginTop = parseInt(window.getComputedStyle(canvasParent).marginTop);
        // top += fabricOffset + canvasContainerMarginTop;

        canvasWithObject.canvasElement.scrollIntoView();
        this.element?.scrollTo(0, (this.element?.scrollTop || 0) + fabricOffset - offset);
        canvasWithObject.fabricObject.wiggleObject();
    }

    calculateTopPercent(fabricObject: fabric.Object) {
        if (!fabricObject.top) {
            throw new Error("Object top ws not defined.");
        }
        let correctCanvas = this.canvasObjects[this.convertPageNumberToIndex(fabricObject.canvas?.pageNumber ?? 0)].fabricCanvas;
        return ((fabricObject.top / correctCanvas.getHeight()) * 100) || 0;
    }

    calculateLeftPercent(fabricObject: fabric.Object) {
        if (!fabricObject.left) {
            throw new Error("Object left was not defined.");
        }
        let correctCanvas = this.canvasObjects[this.convertPageNumberToIndex(fabricObject.canvas?.pageNumber ?? 0)].fabricCanvas;
        return ((fabricObject.left / correctCanvas.getWidth()) * 100) || 0;
    }

    calculateWidthPercent(fabricObject: fabric.Object) {
        if (!fabricObject.width) {
            throw new Error("Object width was not defined.");
        }
        if (!fabricObject.scaleX) {
            throw new Error("Object scaleX was not defined.")
        }

        let correctCanvas = this.canvasObjects[this.convertPageNumberToIndex(fabricObject.canvas?.pageNumber ?? 0)].fabricCanvas;
        return (((fabricObject.width * fabricObject.scaleX) / correctCanvas.getWidth()) * 100) || 0;
    }

    calculateHeightPercent(fabricObject: fabric.Object) {
        if (!fabricObject.height) {
            throw new Error("Object height was not defined.");
        }
        if (!fabricObject.scaleY) {
            throw new Error("Object scaleY was not defined.")
        }

        let correctCanvas = this.canvasObjects[this.convertPageNumberToIndex(fabricObject.canvas?.pageNumber ?? 0)].fabricCanvas;
        return (((fabricObject.height * fabricObject.scaleY) / correctCanvas.getHeight()) * 100) || 0;
    }
}